import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space } from 'styled-system';
import propTypes from '@styled-system/prop-types';
import ListItem from '../ListItem';

export const UnorderedListContainer = styled.ul(space);

export const OrderedListContainer = styled.ol(space);

const List = ({
    children,
    variant,
    ...otherProps
}) => {

    const ListContainer = variant === 'unordered' ? UnorderedListContainer : OrderedListContainer;

    return (
        <ListContainer
            {...otherProps}
        >
            {children}
        </ListContainer>
    );
};

List.propTypes = {

    ...propTypes.space,

    children: PropTypes.node.isRequired,
    variant: PropTypes.string.isRequired
};

List.defaultProps = {
    marginBottom: '24px',
    marginTop: '8px',
    variant: 'unordered'
};

export const ListGenerator = ({
    ListComponent: List,
    items,
    ItemComponent: Item,
    ...otherProps
}) => (
    <List
        {...otherProps}
    >
        {items.map(({ content, key, ...otherItemProps }, i) => (
            <Item
                key={key !== undefined ? key : i}
                {...otherItemProps}
            >
                {content}
            </Item>
        ))}
    </List>
);

ListGenerator.propTypes = {
    ItemComponent: PropTypes.elementType.isRequired,
    items: PropTypes.array.isRequired,
    ListComponent: PropTypes.elementType.isRequired
};

ListGenerator.defaultProps = {
    ItemComponent: ListItem,
    items: [],
    ListComponent: List
};

export default List;
